import React from 'react'
import SupplierContainer from '../../Containers/Supplier'
function FindSupplier() {
  return (
   <SupplierContainer/>
  )
}

export default FindSupplier